import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-eye1",
  "use": "icon-eye1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-eye1\"><path d=\"M512 255.78c-194.98 0-360.39 106.95-421.96 256 61.57 149.05 226.98 256 421.96 256s360.39-106.95 421.96-256c-61.57-149.05-226.98-256-421.96-256z m0 448c-106.04 0-192-85.96-192-192s85.96-192 192-192 192 85.96 192 192-85.96 192-192 192z\" fill=\"#707070\" p-id=\"1763\" /><path d=\"M512 511.78m-128 0a128 128 0 1 0 256 0 128 128 0 1 0-256 0Z\" fill=\"#707070\" p-id=\"1764\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/eye1.svg
// module id = TFsh
// module chunks = 60